import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export default function LoadingButton({ 
    onClick, 
    loading, 
    className = '', 
    children, 
    disabled = false,
    type = 'button',
    form
}) {
    return (
        <button
            type={type}
            className={`loading-button ${className} ${loading ? 'loading' : ''}`}
            onClick={onClick}
            disabled={loading || disabled}
            form={form}
        >
            {loading ? (
                <>
                    <FontAwesomeIcon icon={faSpinner} spin />
                    <span>{children}</span>
                </>
            ) : (
                children
            )}
        </button>
    );
} 